import { lazyWithReload } from "@/utils/lazyWithReload";

/**
 * The only import site of `./PdfFirstPage`, which brings in `react-pdf` /
 * `pdfjs-dist` — keeps the `pdf-viewer` chunk (vite.config.ts `manualChunks`)
 * out of whatever bundle shows a PDF thumbnail.
 */
export const PdfFirstPageLazy = lazyWithReload(() => import("./PdfFirstPage"));
